var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
            ['item', 'inventory_dashboard', 'item_new'].includes(
                _vm.$route.name
            )
        )?_c('Item'):_vm._e(),(_vm.$route.name === 'purchase_order')?_c('PurchaseOrder'):(_vm.$route.name === 'receipt')?_c('Receipt'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }